export default class authUser {

	userId    = '';
	name  = '';
	email = '';
	hasTerminal = false;
	terminalType = '';
	terminalId = '';
	roles = [];


	constructor( authUser ) {
		this.userId= authUser.userId || '';
		this.name  = authUser.name || '';
		this.email = authUser.email || '';
		this.roles = authUser.roles || [];
		this.hasTerminal = authUser.hasTerminal || false;
		this.terminalType = authUser.terminalType || '';
		this.terminalId = authUser.terminalId || '';
	}

}
